import {RouteUrls} from '../../../shared/constants/RouteUrls';
import {PermissionLink} from '../../../shared/permission/PermissionLink';
import {Actions, ApiEndpoints} from '../../../shared/constants/ApiEndpoints';

export interface NavItem {
  title: string;
  icon: string;
  route: string;
  permissionLink: string;
  sideMenuKey: string;
  keywords: string[];
}

export const primaryNavItems: NavItem[] = [
  {
    title: 'Dashboard',
    icon: 'dashboard',
    route: '/dashboard',
    permissionLink: null,
    sideMenuKey: '/dashboard',
    keywords: ['home', 'overview']
  },
  {
    title: 'Account Settings',
    icon: 'settings',
    route: '/' + RouteUrls.ACCOUNT_SETTINGS.MODULE_BASE,
    permissionLink: PermissionLink.appendLink(ApiEndpoints.RES.USER, Actions.BASE_ACTIONS.READ),
    sideMenuKey: '/account-settings',
    keywords: ['users', 'permissions', 'admin']
  },
  {
    title: 'Applications',
    icon: 'description',
    route: '/application',
    permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCR.APPLICATION, Actions.BASE_ACTIONS.READ) + ',' +
      PermissionLink.appendLink(ApiEndpoints.ACCR.APPLICATION, Actions.ACCREDITATION.CUSTOM_READ),
    sideMenuKey: '/application',
    keywords: ['apply', 'new application']
  },
  {
    title: 'Facility Information',
    icon: 'business',
    route: '/facility',
    permissionLink: PermissionLink.appendLink(ApiEndpoints.RES.FACILITY, Actions.BASE_ACTIONS.FETCH),
    sideMenuKey: '/facility',
    keywords: ['facility', 'building', 'site']
  },
  {
    title: 'Survey',
    icon: 'assignment',
    route: '/' + RouteUrls.SURVEY.MODULE_BASE,
    permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ),
    sideMenuKey: '/survey',
    keywords: ['survey', 'inspections', 'surveyors']
  },
  {
    title: 'Accreditation Cycle',
    icon: 'verified',
    route: '/' + RouteUrls.ACCREDITATION.MODULE_BASE,
    permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCR.ACCREDITATION, Actions.BASE_ACTIONS.READ),
    sideMenuKey: '/accreditation',
    keywords: ['accreditation', 'certificates']
  },
  {
    title: 'Finances',
    icon: 'account_balance',
    route: '/' + RouteUrls.FINANCIAL.FACILITIES_LIST.MODULE_BASE,
    permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.INVOICE, Actions.BASE_ACTIONS.READ) + ',' +
      PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.READ) + ',' +
      PermissionLink.appendLink(ApiEndpoints.ACCOUNT.SALE_ORDER, Actions.BASE_ACTIONS.READ),
    sideMenuKey: '/financial',
    keywords: ['invoices', 'payments', 'billing', 'customers', 'estimates']
  },
  {
    title: 'Investigation',
    icon: 'search',
    route: '/' + RouteUrls.INVESTIGATION.MODULE_BASE,
    permissionLink: PermissionLink.appendLink(ApiEndpoints.INVESTIGATION.INVESTIGATION, Actions.BASE_ACTIONS.READ),
    sideMenuKey: '/investigation',
    keywords: ['investigation', 'cases']
  },
  {
    title: 'Reports',
    icon: 'bar_chart',
    route: '/' + RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT,
    permissionLink: PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ),
    sideMenuKey: '/external-report',
    keywords: ['reports', 'cms', 'washington', 'analytics']
  },
  {
    title: 'History',
    icon: 'history',
    route: '/history',
    permissionLink: PermissionLink.appendLink(ApiEndpoints.HISTORY.HISTORY, Actions.BASE_ACTIONS.READ),
    sideMenuKey: null,
    keywords: ['history', 'audit', 'log']
  },
  {
    title: 'Notifications',
    icon: 'notifications',
    route: '/notifications/list',
    permissionLink: null,
    sideMenuKey: null,
    keywords: ['notifications', 'alerts']
  }
];

export const qboNavItem: NavItem = {
  title: 'Connect to Quickbooks',
  icon: 'link',
  route: null,
  permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.QBO, 'connect'),
  sideMenuKey: null,
  keywords: ['quickbooks', 'qbo', 'accounting']
};
